import React from 'react';
import getFormatMessage from '../../../../locales/get-format-message';
import { IAPIGameItem } from '../../../../model/api-modules';
import { GameAvatar } from '../../common/game-avatar';
import './style.scss';

interface IProps {
  readonly selectedGame: IAPIGameItem;
}

export const GameBaseInfoComponent = (props: IProps) => {
  return (
    <div className="game-base-info-box">
      <div className="overview-left">
        <GameAvatar
          width="64px"
          name={props.selectedGame.gameName}
          color={props.selectedGame.gameColor}
          fontSize="40px"
        />
        <div className="game-box">
          <div className="game-name">{props.selectedGame.gameName}</div>
          <div className="game-id">
            {getFormatMessage('title_id')}: {props.selectedGame.gameID}
          </div>
        </div>
      </div>
      <div className="overview-right"></div>
    </div>
  );
};
